export const SERVICE_GROUPS = [
    {
        title: 'Onboarding',
        services: ['Clinic Agreements', 'Clinic Verification', 'Clinic Storage'],
    },
    {
        title: 'Configuration',
        services: [
            'Clinic Reminder Setting',
            'Clinic Hours',
            'Clinic Recall Setting',
            'Clinic Recall Times',
        ],
    },
    {
        title: 'Users & Data',
        services: ['Clinic Users', 'Patients'],
    },
    {
        title: 'Templates',
        services: ['SMS Templates', 'Email Templates', 'Call Templates'],
    },
];

export const getServiceIconClass = (serviceName) => {
    switch (serviceName) {
        case 'Clinic Agreements':
            return 'bi-file-earmark-medical';
        case 'Clinic Verification':
            return 'bi-shield-check';
        case 'Clinic Storage':
            return 'bi-database';
        case 'Clinic Reminder Setting':
            return 'bi-bell';
        case 'Clinic Hours':
            return 'bi-clock';
        case 'Clinic Recall Setting':
            return 'bi-calendar-check';
        case 'Clinic Recall Times':
            return 'bi-watch';
        case 'Clinic Users':
            return 'bi-people';
        case 'SMS Templates':
            return 'bi-chat-left-text';
        case 'Email Templates':
            return 'bi-envelope';
        case 'Call Templates':
            return 'bi-telephone';
        case 'Patients':
            return 'bi-person-badge';
        default:
            return 'bi-gear';
    }
};

export const getServiceIconTone = (serviceName) => {
    switch (serviceName) {
        case 'Clinic Agreements':
        case 'Clinic Verification':
        case 'Clinic Storage':
            return 'onboarding';
        case 'Clinic Reminder Setting':
        case 'Clinic Hours':
        case 'Clinic Recall Setting':
        case 'Clinic Recall Times':
            return 'configuration';
        case 'Clinic Users':
        case 'Patients':
            return 'users';
        case 'SMS Templates':
        case 'Email Templates':
        case 'Call Templates':
            return 'templates';
        default:
            return 'default';
    }
};

export const getStatusLabel = (status) => {
    switch (status) {
        case 'COMPLETED':
            return 'Completed';
        case 'PENDING':
            return 'Pending';
        case 'INCOMPLETE':
            return 'Incomplete';
        default:
            return 'Unknown';
    }
};

export const getStatusBadgeClass = (status) => {
    switch (status) {
        case 'COMPLETED':
            return 'clinic-account-status-badge--completed';
        case 'PENDING':
            return 'clinic-account-status-badge--pending';
        case 'INCOMPLETE':
            return 'clinic-account-status-badge--incomplete';
        default:
            return 'clinic-account-status-badge--incomplete';
    }
};

export const getStatusIconClass = (status) => {
    switch (status) {
        case 'COMPLETED':
            return 'bi-check-circle';
        case 'PENDING':
            return 'bi-hourglass-split';
        case 'INCOMPLETE':
            return 'bi-exclamation-circle';
        default:
            return 'bi-question-circle';
    }
};

export const calculateCompletionStats = (services) => {
    if (!services?.length) {
        return { completed: 0, pending: 0, incomplete: 0, total: 0, percentage: 0 };
    }

    const completed = services.filter((service) => service.status === 'COMPLETED').length;
    const pending = services.filter((service) => service.status === 'PENDING').length;
    const incomplete = services.filter((service) => service.status === 'INCOMPLETE').length;
    const total = services.length;
    const percentage = total > 0 ? Math.round((completed / total) * 100) : 0;

    return { completed, pending, incomplete, total, percentage };
};

export const getGroupedServices = (services) => {
    if (!services?.length) return [];

    const serviceMap = new Map(services.map((service) => [service.serviceName, service]));
    const groupedNames = new Set(SERVICE_GROUPS.flatMap((group) => group.services));

    const groups = SERVICE_GROUPS.map((group) => ({
        title: group.title,
        items: group.services
            .filter((name) => serviceMap.has(name))
            .map((name) => serviceMap.get(name)),
    })).filter((group) => group.items.length > 0);

    const otherItems = services.filter((service) => !groupedNames.has(service.serviceName));
    if (otherItems.length > 0) {
        groups.push({ title: 'Other', items: otherItems });
    }

    return groups;
};
